<template>
    <div id="`grouplist`">
        <app-gridview 
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>


<script>
import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },

    data() {
        return {
            pageTitle: this.$t('setupgrp.grplist'),
            dataHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '50px', sortable: false},
                { text: this.$t('columns.grouptype'), width: '150px', value: 'gtypedesc'},
                { text: this.$t('columns.disable'), width: '150px', value: 'isDisable'},
            ],

            dataItems: [],
            loading: false,
            errMsg: '',
             search: this.$route.params.search,
        }
    },

    methods: {

        loadAffectTypes() {
            const vm = this;

            this.$store.dispatch('get', {url: '/group/all'})
            .then(res => {
                vm.dataItems = res.data.rec;
            })
            .catch(err => {
                vm.errMsg = err;
            });
        },

        editItemHandler(item) {
            this.$router.push({name: 'groupedit', params: { id: item.id, search: item.search  } });
        },

        newRecordHandler() {
            this.$router.push({name: 'groupnew'});
        }
    },

    mounted() {
        this.loadAffectTypes();
    }
}
</script>